import React from 'react';
import { GeoData } from './entities';

declare const global: {
  geo: GeoData;
};

export const useGeo = (): GeoData | null => {
  const [geo, setGeo] = React.useState<GeoData | null>(null);
  React.useEffect(() => {
    if (!global.geo) {
      window.addEventListener('geo', () => {
        setGeo(global.geo);
      });
    } else {
      setGeo(global.geo);
    }
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      window.removeEventListener('geo', () => {});
    };
  }, []);
  return geo;
};
